<template>

    <div id="close-session-alert-modal" class="close-session-alert-modal modal fade" tabindex="1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-pdv-small modal-dialog-centered">
            <div class="modal-content">
                <button type="button" class="close" @click="onClose" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>

                <div class="main-content">
                    <h3>TU SESIÓN CERRARÁ EN</h3>

                    <span class="fs-99 lh-102 mb-0">{{currentTimer | onlySeconds}}</span>

                    <span class="fs-20 lh-23">SEGUNDOS</span>

                    <p>¿Necesitas más tiempo?</p>

                    <a @click="onContinue" href="#" data-dismiss="modal" class="btn-pdv-primary ">SI, CONTINUAR EN PDV</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {mapState,mapMutations} from 'vuex';
    export default {
        data() {
            return {
                currentTimer: '00:30'
            }
        },
        computed : {
            ...mapState(['localPageTimer'])
        },
        mounted() {
            // Obtener el timer actual del mixin
            this.updateTimer();
            
            // Actualizar el timer cada segundo
            this.timerInterval = setInterval(() => {
                this.updateTimer();
            }, 1000);
            
            // Escuchar evento de timer llegando a cero
            this.$root.$on('timer-reached-zero', () => {
                this.closeModal();
            });
        },
        beforeDestroy() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
            }
            // Limpiar event listener
            this.$root.$off('timer-reached-zero');
        },
        methods : {
            ...mapMutations(['setTimerPageExpired']),
            updateTimer() {
                // Solicitar el timer actual al mixin
                this.$root.$emit('get-current-timer', (timer) => {
                    if (timer) {
                        this.currentTimer = timer;
                        
                        // Si el timer llega a 00:00, cerrar automáticamente este modal
                        if (timer === '00:00') {
                            this.closeModal();
                        }
                    }
                });
            },
            closeModal() {
                
                // Limpiar el intervalo del modal
                if (this.timerInterval) {
                    clearInterval(this.timerInterval);
                    this.timerInterval = null;
                }
                
                // Cerrar el modal usando múltiples métodos para asegurar que se cierre
                try {
                    // Método 1: Usar jQuery modal (verificar que jQuery esté disponible)
                    if (window.$ && typeof window.$.fn.modal === 'function') {
                        window.$('#close-session-alert-modal').modal('hide');
                    }
                    
                    // Método 2: Usar el helper si existe
                    const helper = document.getElementById('helperSessionModal');
                    if (helper) {
                        helper.click();
                    }
                    
                    // Método 3: Remover backdrop y clases usando vanilla JS
                    setTimeout(() => {
                        const backdrops = document.querySelectorAll('.modal-backdrop');
                        backdrops.forEach(backdrop => backdrop.remove());
                        document.body.classList.remove('modal-open');
                    }, 100);
                    
                } catch (error) {
                    console.error('❌ Error al cerrar modal:', error);
                }
            },
            onContinue(){
                // Marcar que el timer ha sido extendido
                this.setTimerPageExpired(true);
                
                // Emitir evento para reiniciar el timer en otros componentes
                this.$root.$emit('reset-inactivity-modal');
                
                // Cerrar el modal
                window.$('#helperSessionModal')[0].click();
            },
            onClose(){
                // Solo cerrar el modal sin reiniciar el timer
                window.$('#helperSessionModal')[0].click();
            }
        },
        filters : {
            onlySeconds(time){
                return moment(time,'mm:ss').format('ss')
            }
        }
    }
</script>

<style scoped lang="scss">
    .close-session-alert-modal {
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv-small {
            max-width: 481px;
            .modal-content{
                background: #313541;
                padding: 48px 40px;
                border-radius: 1px;
                box-shadow: 0 0 12px 3px #00000038;
                
                button.close{
                    position: absolute;
                    top: 15px;
                    right: 15px;
                    opacity: 1;
                    span{
                        font-size: 30px;
                        color: #fff;
                    }
                }
                .main-content{
                    text-align: center;
                    h3{
                        font-size: 20px;
                        line-height: 23px;
                        margin-bottom: 33px;
                        color: #fff;
                        @include alternative-bold;
                    }
                    span{
                        color: #fff;
                        @include font-extra-bold-regular;
                        display: block;
                    }

                    p{
                        font-size: 18px;
                        line-height: 26px;
                        margin-top: 31px;
                        margin-bottom: 17px;
                        color: #fff;
                        @include alternative-regular;
                    }
                    .btn-pdv-primary{
                        padding: 14px 40px;
                    }
                }
            }

        }
    }

</style>